const isAuthenticated = () => {
  const token = localStorage.getItem("token");
  if (!token) {
    return false;
  }
  try {
    return token;
  } catch (error) {
    console.error("Error parsing token:", error);
    return false;
  }
};

const clearToken = () => {
  localStorage.clear("token");
  localStorage.clear("user");
};

const setStoreTheme = (theme) => {
  localStorage.setItem("theme", theme);
};

const getTheme = () => {
  return localStorage.getItem("theme")
    ? localStorage.getItem("theme")
    : "light";
};

export { isAuthenticated, clearToken, getTheme, setStoreTheme };
